import {html, css, LitElement} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {repeat} from 'lit/directives/repeat.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import {property} from 'lit/decorators/property.js';

import {FeatureSelect} from '../featureSelect/featureSelect';

import radio from '../../../icons/radio';
import checkmark from '../../../icons/checkmark';
import store from '../../store';

@customElement('model-select')
export class ModelSelect extends connect(store)(LitElement) {

	static styles = [
		FeatureSelect.styles,
		css`
			:host {
			}

			.title {
				display: flex;
				justify-content: space-between;
				align-items: center;
				font: var(--font-widget-title);
				color: var(--color-widget-text);
				margin-bottom: 12px;
			}

			.values {
				display: flex;
				flex-direction: column;
			}

			.selectedValue {
				color: var(--color-text-widget-value);
				font-size: var(--font-size-widget-small);
				margin-left: auto;
			}

			.satisfied {
				color: var(--color-text-widget-title);
			}

			.notSatisfied {
				color: var(--color-warn);
			}
		`];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.models = state.productData.models;
		this.modelsTranslations = state.productData.modelTranslations;
	}
	render() {
		if (!this.models || this.models.length === 0) return null;

		return html`
			<div>
				<div class="title">
					<trans-label key="LU_Type" context="D" default="Model"></trans-label>
				</div>
				<div class="values">
					${repeat(this.models,
							(model) => model.productModelId,
							(model) => html`
								<model-select-item .model=${model} .translations=${this.modelsTranslations}></model-select-item>
							`)}
				</div>
			</div>

		`;
	}
}
